export default "__VITE_ASSET__Di$3qnI___"